module.exports = __webpack_public_path__ + "img/yogesh_skills.1e917f41.jpg";